export const sources={};export const img={src:"__VITE_ASSET__OxgPY7jd89vmgHQlmb5h_Q__",w:640,h:640};export default{sources:sources,img:img};